import { useFeatureAccessSettings } from '../featureAccessSettings';

type UseCanUserAccessLeadershipCorner = () => boolean;
export const useCanUserAccessLeadershipCorner: UseCanUserAccessLeadershipCorner = () => {
  const featureAccessSettings = useFeatureAccessSettings();

  return !!featureAccessSettings?.viewerCanAccessLeadershipCorner;
};

type UseCanUserAdminLeadershipCorner = () => boolean;
export const useCanUserAdminLeadershipCorner: UseCanUserAdminLeadershipCorner = () => {
  const featureAccessSettings = useFeatureAccessSettings();

  return !!featureAccessSettings?.viewerCanEditLeaderSettings;
};
